export default "__VITE_ASSET__DuGcBD_0__"